import { render, staticRenderFns } from "./contratosRegularizados.vue?vue&type=template&id=3ba3357d"
import script from "./contratosRegularizados.vue?vue&type=script&lang=js"
export * from "./contratosRegularizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports